import React from 'react';
import { styled } from 'styled-components';
import { Input } from '../input';
import { TextButton } from '../buttons/textButton';

const PropertiesPanelPropertyContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 12px;
    font-family: ${(props) => props.theme.app.font};
    padding: 6px 0;
    border-bottom: 1px dashed ${(props) => props.theme.app.borderColor}44;

    &:last-child {
        border-bottom: none;
    }
`;

export const PropertiesPanelProperty = (props: { children: React.ReactNode }) => {
    return <PropertiesPanelPropertyContainer>{props.children}</PropertiesPanelPropertyContainer>;
};

export const PropertiesPanelLabel = styled.label`
    font-size: 12px;
`;

export const PropertiesPanelControl = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    position: relative;
    width: 100%;
`;

export const PropertiesPanelPropertyContent = styled.div`
    grid-column: 1 / span 2;
`;

export const CompactInput = styled(Input)`
    height: 28px;
    padding: 3px 8px;
    font-size: 12px;
    flex: 1;
    min-width: 0;
`;

export const CompactButton = styled(TextButton)`
    font-size: 12px;
    white-space: nowrap;
`;
